<template>
  <div class="pdt-20px">
    <div class="card">
      <header class="header-card has-text-white">
        {{ $t(`${prefixTrad}.informations.title`) }}
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-6-widescreen is-5-fullhd">
            <left-information
              :facture="commande"
              :labelIntervenant="$t(`${prefixTrad}.informations.labelIntervenant`)"
              :sousTypes="constantes.SOUS_TYPES"
              @tiersUpdated="$emit('tiersUpdated')"
              isBonReception>
            </left-information>
          </div>
          <div class="column is-6-widescreen is-offset-0-widescreen is-5-fullhd is-offset-2-fullhd">
            <right-information
              :facture="commande">
            </right-information>
          </div>
        </div>
        <div class="mgt-40px">
          <liste-lignes-ventes
            :error="false"
            :dcf="commande"
            :breadcrumb="[]"
            :sens="constantes.SENS_ACHAT"
            :commandeAchatARapprocher="[]"
            :categoriesProduct="[constantes.CATEGORIE_IMPRESSION_AFFICHE]"
            @calcul="calcul"
            @typeProduitChange="$emit('typeProduitChange')">
          </liste-lignes-ventes>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <commentaires
        :type="commande.type"
        :dcf="commande"
        :devisCommandeFacture="commande"
        :afficherCommentaireFacture="false">
      </commentaires>
    </div>
  </div>
</template>

<script>
import Commentaires from '@/components/bodac/dcf/addEditDcf/commentaires/commentaires';
import ListeLignesVentes from '@/components/devisCommandes/editionDevisCommande/listeLignesVentes';
import LeftInformation from '@/components/baux/factureAchatARapprocher/edition/factureAchatInformation/leftInformation';
import RightInformation from '@/components/baux/factureAchatARapprocher/edition/factureAchatInformation/rightInformation';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import { SENS_ACHAT, SOUS_TYPE_BON_RECEPTION } from '@/configuration/devisConf';
import { CATEGORIE_IMPRESSION_AFFICHE } from '@/configuration/catalogue/produitConf';
import { TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON, LISTE_SOUS_TYPE_FOURNISSEURS_PAGES } from '@/configuration/tiers/tiersConf';

export default {
  name: 'InformationsTab',
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        SENS_ACHAT,
        CATEGORIE_IMPRESSION_AFFICHE,
        SOUS_TYPES: LISTE_SOUS_TYPE_FOURNISSEURS_PAGES
          .map(el => el.code)
          .filter(el => el !== TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON),
      },
    };
  },
  components: {
    LeftInformation,
    RightInformation,
    ListeLignesVentes,
    Commentaires,
  },
  computed: {
    isBonReception() {
      return this.commande.sousType === SOUS_TYPE_BON_RECEPTION;
    },
    prefixTrad() {
      return this.isBonReception ? 'addEditBonReception' : 'addEditCommande';
    },
  },
  methods: {
    calcul() {
      calculCommandeDevis(this.commande);
    },
  },
};
</script>
